module.exports = "<i class=\"fa\" ng-class=\"{'fa-car': isPA, 'fa-home': isHomeowners }\"></i>"